import React from 'react'

import type { IconProps } from './types'

const SimilacLeadgen: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.672 38.828s-1.515-1.408-2.618-.683 1.455 1.996 3.47 3.796z"
        fill="#C3574F"
      />
      <path
        d="M3.672 38.828s-1.515-1.408-2.618-.683 1.455 1.996 3.47 3.796z"
        fill="#FFCB37"
      />
      <path
        d="M39.482 19.767c-1.434-4.128-2.974-5.418-3.712-8.062-1.132-4.048-4.523-9.138-8.222-8.413-5.639-3.466-13.031 1.355-15.27 8.79-.79 2.63-2.325 3.557-3.76 7.685C6.11 26.7 12.993 33.035 20.981 33.213h6.062c7.989-.178 14.848-6.513 12.439-13.446"
        fill="#111"
      />
      <path
        d="M39.784 46.936H7.596a.394.394 0 0 1-.385-.487c.525-2.147 2.2-5.33 4.226-7.418a17.5 17.5 0 0 1 4.793-3.281.4.4 0 0 0 .109-.082 9.7 9.7 0 0 1 3.387-2.21c.067-.102 7.85-.106 7.92 0l.004.004a9.6 9.6 0 0 1 3.39 2.205q.046.052.108.082c1.77.82 3.39 1.93 4.795 3.282 2.026 2.087 3.702 5.271 4.226 7.418a.393.393 0 0 1-.385.486"
        fill="#E3F2FF"
      />
      <path
        d="M27.649 33.458c-2.824 3.762-5.463 3.746-7.92 0 .222-.332.395-.696.511-1.079q.023-.062.04-.122.08-.291.126-.59a5.5 5.5 0 0 0 .063-.867h6.44a5.5 5.5 0 0 0 .172 1.398q.025.096.06.189c.117.38.288.74.508 1.071"
        fill="#FCCAAF"
      />
      <path
        d="M29.937 46.936H17.865c-1.593-10.663 1.863-13.478 1.863-13.478.74 1.04 2.233 1.745 3.962 1.745s3.222-.705 3.958-1.745l.004.004c.09.083 1.115 1.437 1.847 4.284.58 2.254.67 6.866.438 9.19"
        fill="#2D87F3"
      />
      <path
        d="M19.728 33.456a9.6 9.6 0 0 0-3.435 2.262 6.06 6.06 0 0 0-1.504 3.159c-.08.4 1.172.141 1.811-.015a.063.063 0 0 1 .051.111c-1.418.997-1.911 2.232-1.833 2.887a18 18 0 0 0 1.536 5.075h3.02s-1.42-8.314.354-13.479m11 5.52a.06.06 0 0 1-.02-.077.06.06 0 0 1 .071-.035c.64.158 1.893.414 1.812.014a6.03 6.03 0 0 0-1.505-3.159 9.6 9.6 0 0 0-3.438-2.26c1.772 5.164.354 13.477.354 13.477h3.022a18 18 0 0 0 1.536-5.075c.08-.655-.411-1.889-1.832-2.885"
        fill="#BCDEFF"
      />
      <path
        d="M27.141 32.387c-2.288 2.028-4.588 2.036-6.9-.008l.04-.122q.08-.291.125-.59a5.5 5.5 0 0 0 .063-.867h6.44a5.5 5.5 0 0 0 .173 1.398q.024.096.059.189"
        fill="#FF977B"
      />
      <path
        d="M12.215 19.811c-.75.646-.93 1.898-.52 2.875.458 1.087 1.497 2.316 3.49 2.063l-1-5.446c-.729-.052-1.36-.017-1.97.508m23.57 0c-.612-.525-1.242-.56-1.97-.508l-1 5.447c1.993.252 3.032-.975 3.49-2.062.41-.98.23-2.231-.52-2.877"
        fill="#FFB497"
      />
      <path
        d="M14.3 20.306a27 27 0 0 0 .885 4.444c1.229 4.041 5.852 7.09 8.815 7.09s7.586-3.049 8.815-7.09c.425-1.481.725-2.996.895-4.528-1.172-3.14-.781-6.502-1.953-8.503-4.045-6.916-9.946-6.748-14.413.117-1.393 2.14-1.786 5.08-3.044 8.47M11.805 42.12a1.87 1.87 0 0 1-.51-1.328c.064-1.237.135-2.606.004-3.165a.9.9 0 0 0-.551-.693c-.405-.165-.89-.023-.957.31a130 130 0 0 0-.65 3.526.06.06 0 0 1-.052.052.06.06 0 0 1-.06-.045c-.343-1.15-.957-3.694-1.275-4.312-.217-.424-.438-.915-1.158-1.05-.484-.094-.98.285-.957.622.068.9.766 3.656 1.05 4.772a.075.075 0 0 1-.141.043c-.53-.95-1.082-2.86-1.425-3.585-.3-.637-.833-1.402-1.628-1.62a.79.79 0 0 0-1.012.92c.105.464.706 1.357 1.041 2.199.392.984.46 2.156 1.033 3.931.268.66.768 1.199 1.406 1.515a2.27 2.27 0 0 1 1.255 1.538c.056.251.105.495.142.7a.75.75 0 0 0 .739.616h5.071s-.217-3.667-1.365-4.946"
        fill="#FCCAAF"
      />
      <path
        d="M32.125 16.083a4.7 4.7 0 0 0-1.393-.568 10 10 0 0 0-1.415-.24 13 13 0 0 0-2.842.025.488.488 0 1 0 .116.965h.012l.011-.002c.87-.125 1.752-.157 2.628-.095q.653.045 1.292.181c.403.08.791.223 1.15.424l.012.007a.408.408 0 0 0 .43-.694zm-16.295 0c.43-.262.9-.454 1.392-.568a10 10 0 0 1 1.415-.24c.947-.095 1.9-.087 2.844.024a.488.488 0 0 1-.117.965h-.011l-.012-.001a12.3 12.3 0 0 0-2.629-.097q-.652.044-1.291.18a4 4 0 0 0-1.15.424l-.013.007a.408.408 0 0 1-.43-.694z"
        fill="#1B3250"
      />
      <path
        d="M29.752 22.111c-.815.052-1.632.033-2.443-.059-1.566-.176-1.967-2.567-1.962-3.089.006-.575.419-.91.983-1.07a18.8 18.8 0 0 1 5.05-.46c.585.051 1.05.197 1.057.771.006.448-.402 3.766-2.685 3.907m-11.503 0c.814.052 1.632.033 2.442-.059 1.566-.176 1.967-2.567 1.962-3.089-.006-.575-.418-.91-.983-1.07a18.8 18.8 0 0 0-5.05-.46c-.585.051-1.05.197-1.057.771-.005.448.402 3.766 2.686 3.907"
        fill="#fff"
      />
      <path
        d="M24.65 22.127a.56.56 0 0 0-.42.19 1 1 0 0 1-.232.037 1 1 0 0 1-.228-.037.564.564 0 0 0-.983.372c0 .782 1.2.791 1.211.791s1.215-.009 1.215-.79a.56.56 0 0 0-.562-.563"
        fill="#FF977B"
      />
      <path
        d="M28.892 20.383a1.098 1.098 0 1 0 0-2.195 1.098 1.098 0 0 0 0 2.195m-9.784 0a1.098 1.098 0 1 0 0-2.195 1.098 1.098 0 0 0 0 2.195"
        fill="#1B3250"
      />
      <path
        d="M22.358 25.007a.344.344 0 0 0-.346.402 2.03 2.03 0 0 0 3.978 0 .346.346 0 0 0-.345-.402zm-8.338.748a.748.748 0 1 0 0-1.496.748.748 0 0 0 0 1.496m19.961 0a.748.748 0 1 0 0-1.496.748.748 0 0 0 0 1.496"
        fill="#fff"
      />
      <path
        d="M28.852 22.702q-.806 0-1.607-.09c-2.062-.233-2.466-3.1-2.46-3.655.008-.773.516-1.358 1.393-1.605a19 19 0 0 1 5.25-.48c1.032.091 1.56.537 1.57 1.325.008.703-.516 4.31-3.213 4.476q-.471.029-.933.029m1.759-4.735a18.8 18.8 0 0 0-4.128.468c-.57.16-.572.432-.573.534-.005.416.363 2.4 1.462 2.524q1.171.132 2.346.057c1.76-.109 2.162-2.94 2.157-3.338 0-.075-.002-.17-.543-.218a8 8 0 0 0-.721-.027m-11.463 4.735q-.461 0-.934-.03c-2.698-.166-3.222-3.772-3.214-4.475.01-.787.538-1.234 1.57-1.324 1.764-.084 3.53.077 5.25.48.877.247 1.385.832 1.393 1.604.006.555-.399 3.422-2.46 3.654q-.8.09-1.605.09m-1.758-4.735c-.269 0-.513.008-.721.026-.54.048-.542.142-.543.218-.005.4.397 3.23 2.158 3.337q1.175.075 2.345-.056c1.099-.124 1.466-2.108 1.462-2.525 0-.102-.003-.373-.573-.533a18.8 18.8 0 0 0-4.128-.467"
        fill="#E4E8EC"
      />
      <path
        d="M25.348 19.526a.6.6 0 0 1-.15-.02 4.5 4.5 0 0 0-2.398 0 .562.562 0 1 1-.295-1.086 5.6 5.6 0 0 1 2.99 0 .562.562 0 0 1-.15 1.105z"
        fill="#E4E8EC"
      />
      <path
        d="M35.18 21.297c-1.821-3.123-.094-7.666-2.365-11.482C31.57 7.722 29.948 4.5 24.65 4.5s-6.644 2.428-8.025 4.227c-2.9 3.778-1.606 9.447-3.426 12.57-.32.55.76.944 1.153.443 1.2-1.531 3.527-3.934 4.135-7.01.951-4.821 4.496-8.886 8.442-5.955 4.506.063 2.548 9.575 7.097 12.966.51.38 1.474.106 1.153-.444"
        fill="#1B3250"
      />
      <path
        d="M13.823 22.53a1.44 1.44 0 0 1-.795-.235.937.937 0 0 1-.316-1.282c.728-1.247.915-3.018 1.114-4.891.271-2.556.578-5.452 2.356-7.74a.562.562 0 1 1 .889.69c-1.584 2.036-1.859 4.645-2.126 7.168-.203 1.918-.396 3.734-1.162 5.165a.2.2 0 0 0 .128-.014c.183-.234.395-.49.622-.766 1.23-1.492 2.914-3.535 3.402-6.004.683-3.458 2.561-6.247 4.785-7.106 1.44-.556 2.96-.312 4.403.704 2.638.162 3.287 3.015 3.972 6.031.59 2.597 1.259 5.54 3.27 7.04a.4.4 0 0 0 .205.064c-.823-1.571-.906-3.488-.988-5.344-.09-2.057-.183-4.183-1.245-5.899a.562.562 0 1 1 .957-.592c1.215 1.966 1.316 4.241 1.412 6.441.083 1.895.162 3.684.96 5.054a.89.89 0 0 1-.162 1.155 1.52 1.52 0 0 1-1.812.022c-2.343-1.746-3.06-4.905-3.694-7.691-.724-3.185-1.26-5.138-3.075-5.163a.56.56 0 0 1-.328-.11c-1.176-.875-2.343-1.097-3.47-.662-1.844.712-3.486 3.233-4.088 6.274-.544 2.747-2.332 4.917-3.638 6.501-.22.268-.426.518-.606.747a1.21 1.21 0 0 1-.97.443"
        fill="#262626"
      />
      <path
        d="M20.43 19.005a.56.56 0 0 1-.413-.182 1.57 1.57 0 0 0-1.183-.443 1.1 1.1 0 0 0-.817.32.562.562 0 1 1-.88-.7 2.18 2.18 0 0 1 1.656-.743 2.7 2.7 0 0 1 2.051.806.562.562 0 0 1-.414.943m7.14-.001a.562.562 0 0 1-.414-.943 2.7 2.7 0 0 1 2.05-.806 2.2 2.2 0 0 1 1.656.744.562.562 0 0 1-.879.702 1.1 1.1 0 0 0-.816-.32 1.56 1.56 0 0 0-1.183.443.56.56 0 0 1-.414.18"
        fill="#1B3250"
      />
      <path
        d="m29.342 28.008-1.306-.518a.381.381 0 0 0-.48.528l.782 1.533a1.13 1.13 0 0 1 .016.997 8 8 0 1 0 2.138-2.73 1.14 1.14 0 0 1-1.15.19"
        fill="#C3574F"
      />
      <path
        d="M32.845 34.92a.987.987 0 1 0 0-1.973.987.987 0 0 0 0 1.973m3.217.09a.667.667 0 1 0 0-1.335.667.667 0 0 0 0 1.335m2.73-.793a.472.472 0 1 0 0-.944.472.472 0 0 0 0 .944"
        fill="#fff"
      />
    </svg>
  )
}

export default SimilacLeadgen
